import Vue from 'vue';
import PhoneMaskInput from 'vue-phone-mask-input';
import googleCalendar from '../components/googleCalendar.vue';

//регистрация глобальных компонентов
Vue.component('phone-mask-input', PhoneMaskInput);
Vue.component('google-calendar', googleCalendar);
